export default __webpack_public_path__ + "static/media/tv.ddece430.png";